<template>
  <div class="panel mui-panel">
    <div class="mui-panel-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      scrollPos: 0
    }
  }
}
</script>

<style lang="sass">
.mui-panel
  width: 100%
</style>



// WEBPACK FOOTER //
// src/components/MUIPanel.vue